import { useState, useEffect } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import { getProfiles } from 'api';

export default function usePartner(env) {
  const token = useAuthHeader()();

  const [partnerList, setPartnerList] = useState([]);

  useEffect(() => {
    const initPartnerList = async () => {
      const partners = await getProfiles(token, env);

      setPartnerList(partners);
    };

    initPartnerList();
  }, [token, env]);

  return { partnerList };
}
